import { Component, Inject } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueModel } from '../../model/issue.model';
import { IssueService } from '../../service/issue.service';
@Component({
  selector: 'keyword-dialog',
  templateUrl:
    'console/app-js/modules/issue/components/keyword-dialog/keyword-dialog.component.html'
})
export class KeywordDialogComponent extends APIOperableComponent {
  title: String = 'Edit Keyword';
  protected issueModel: IssueModel = new IssueModel();
  protected isDuplicateKeyword = false;
  protected duplicateKeywords: Array<string> = [];
  protected issueKeywords;
  constructor(
    @Inject('currentIssueModel') currentIssueModel: IssueModel,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private activeDialogService: UIActiveDialogService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
    this.issueModel = currentIssueModel[0];
    this.issueModel.keywords =
      currentIssueModel[0].keywords === 'Not Set'
        ? []
        : currentIssueModel[0].keywords;

    this.issueKeywords = this.issueModel.keywords;
  }

  onSave(): void {
    if (!this.checkDuplicateKeyword()) {
      let editedKeywords = JSON.parse(JSON.stringify(this.issueKeywords));
      this.issueModel.keywords = Array.isArray(editedKeywords)
        ? this.issueKeywords
        : editedKeywords.split(',');
      this.issueModel.keywords = this.issueModel.keywords.map(keyword => {
        return keyword.trim();
      });
      this.startProgress();
      this.issueService.updateIssue(this.issueModel).subscribe(
        result => {
          if (result.responseCode === 200) {
            this.finishProgress();
            this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
            this.activeDialogService.close(true);
          } else {
            this.onAPIError(result.errorMessage);
          }
        },
        err => {
          this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
        }
      );
    }
  }

  onCancel(): void {
    this.issueKeywords = null;
    this.activeDialogService.dismiss();
  }

  /**
   * Check if the keywords are duplicate.
   * @returns {boolean}
   */
  protected checkDuplicateKeyword(): boolean {
    let hashMap = {};
    this.duplicateKeywords = [];

    let editedKeywords = JSON.parse(JSON.stringify(this.issueKeywords));
    let testArray = Array.isArray(editedKeywords)
      ? this.issueKeywords
      : editedKeywords.split(',');

    testArray.forEach(keyword => {
      keyword = keyword.trim().toLowerCase();
      if (!hashMap[keyword]) {
        hashMap[keyword] = 0;
      }
      hashMap[keyword] += 1;
    });

    for (let keyword in hashMap) {
      if (hashMap[keyword] >= 2) {
        this.duplicateKeywords.push(keyword);
      }
    }

    if (this.duplicateKeywords.length > 0) {
      this.isDuplicateKeyword = true;
      return true;
    } else {
      this.isDuplicateKeyword = false;
      return false;
    }
  }
}
